import { Stack, Typography } from '@mui/material';

const RenderForbidden = () => {
  return (
    <>
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='center'
        sx={(theme) => ({
          width: '100%',
          height: '100%',
          padding: theme.spacing(2),
        })}>
        <Typography align='center' variant='body1' component='span'>
          Доступ ограничен
        </Typography>
        <Typography align='center' color='text.secondary' variant='caption' component='span'>
          Под вашей учетной записью доступ ограничен
        </Typography>
      </Stack>
    </>
  );
};

export default RenderForbidden;
